import React from 'react'
import '../Css/Partnership.css'

const Partnership = () => {
  return (
    <div>
      
      <div className="text-center my-5"><h1>Partnership</h1></div>
      <div className="partnershipPera"><p> <span> Eagle Eye Security Service</span> started out with only 8 clients back in 2018. Now the company has an enormous clientele of over 1500 customers.

Our vast range of activities leads us to cooperate with established names, associations and organizations locally and internationally. Therefore our affiliations repertoire speaks for itself.

Eagle Eye Security Service is a permanent member of BANGLADESH PRIVATE SECURITY SERVICES PROVIDERS ASSOCIATION (BPSSPA). Besides we are also member of prestigious AMCHAM & French Chamber. We have close cooperation & affiliation with the following international security organization / institution.</p>
    

      </div>
      
      <div className="image">
        <img src="https://scontent.fdac27-2.fna.fbcdn.net/v/t39.30808-6/275784816_101721449136683_8312195913096282799_n.png?_nc_cat=103&ccb=1-7&_nc_sid=e3f864&_nc_ohc=o9_iBXqx-xMAX9AIHt7&_nc_ht=scontent.fdac27-2.fna&oh=00_AT-y8Fqms26zE_kRthJlmxw9HEeo2xyhfxdb7ONZui6QIQ&oe=6315EE7C" alt="" />
      </div>
    </div>
  )
}

export default Partnership
